import React from "react";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import "./HostVenuePage.css";
import { IMAGES } from "../utils/GetImages";
import { getTranslation } from "../utils/translation";

export default function HostVenuePage() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const BecomeAHostImg = IMAGES["HostVenuePage-BecomeAHost.png"];
  const Benefit1Img = IMAGES["HostVenuePage-Benefit1.png"];
  const Benefit2Img = IMAGES["HostVenuePage-Benefit2.png"];
  const Benefit3Img = IMAGES["HostVenuePage-Benefit3.png"];
  const Benefit4Img = IMAGES["HostVenuePage-Benefit4.png"];

  const onContactClick = () => {
    navigate("/contact?from=HOST");
  };

  const onLearnMoreClick = () => {
    navigate("/get-apl");
  };

  const scrollToSection = (sectionId) => {
    console.log("Attempting to scroll to section:", sectionId);

    // 先嘗試直接使用 CSS scroll-behavior
    const element = document.querySelector(`#${sectionId}`);
    if (element) {
      console.log("Element found, scrolling...");
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    } else {
      console.error("Element not found with ID:", sectionId);
      // 列出所有存在的 section IDs 進行調試
      const allSections = document.querySelectorAll("section[id]");
      console.log(
        "Available sections:",
        Array.from(allSections).map((s) => s.id)
      );
    }
  };

  return (
    <div>
      <section id="host-venue" className="host-venue-section">
        <div className="host-venue-container">
          <div className="host-venue-content">
            <div className="host-venue-text">
              <h2 className="host-venue-title">
                {getTranslation(i18n, "hostVenuePage.title")}
              </h2>
              <p className="host-venue-subtitle">
                {getTranslation(i18n, "hostVenuePage.subtitle")}
              </p>
              <h3 className="host-venue-why">
                {getTranslation(i18n, "hostVenuePage.whyChoose")}
              </h3>
              <p className="host-venue-description">
                {getTranslation(i18n, "hostVenuePage.description")}
              </p>
              <div className="host-venue-contact">
                <h4 className="host-venue-contact-title">
                  {getTranslation(i18n, "hostVenuePage.contactTitle")}
                </h4>
                <p className="host-venue-email">
                  {getTranslation(i18n, "hostVenuePage.email")}
                </p>
                <p className="host-venue-contact-desc">
                  {getTranslation(i18n, "hostVenuePage.contactDescription")}
                </p>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={onContactClick}
                  className="host-venue-button contact-us-button contact-us-button-large"
                >
                  {getTranslation(i18n, "hostVenuePage.button")}
                </Button>
              </div>
            </div>
            <div className="host-venue-image">
              <img
                src={BecomeAHostImg}
                alt="Host Venue"
                className="host-venue-img"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="benefits" className="benefit-cards">
        <div className="benefit-card">
          <img
            src={Benefit1Img}
            alt="App Preview"
            className="benefit-card-image"
          />
          <div className="benefit-card-content">
            <h2>{getTranslation(i18n, "homePage.benefit1.title")}</h2>
            <p>{getTranslation(i18n, "homePage.benefit1.description")}</p>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={onLearnMoreClick}
            >
              {getTranslation(i18n, "homePage.benefit1.button")}
            </Button>
          </div>
        </div>
        <div className="benefit-card reverse">
          <img
            src={Benefit2Img}
            alt="App Preview"
            className="benefit-card-image"
          />
          <div className="benefit-card-content">
            <h2>{getTranslation(i18n, "homePage.benefit2.title")}</h2>
            <p>{getTranslation(i18n, "homePage.benefit2.description")}</p>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={onLearnMoreClick}
            >
              {getTranslation(i18n, "homePage.benefit2.button")}
            </Button>
          </div>
        </div>
        <div className="benefit-card">
          <img
            src={Benefit3Img}
            alt="App Preview"
            className="benefit-card-image"
          />
          <div className="benefit-card-content">
            <h2>{getTranslation(i18n, "homePage.benefit3.title")}</h2>
            <p>{getTranslation(i18n, "homePage.benefit3.description")}</p>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={onLearnMoreClick}
            >
              {getTranslation(i18n, "homePage.benefit3.button")}
            </Button>
          </div>
        </div>
        <div className="benefit-card reverse">
          <img
            src={Benefit4Img}
            alt="App Preview"
            className="benefit-card-image"
          />
          <div className="benefit-card-content">
            <h2>{getTranslation(i18n, "homePage.benefit4.title")}</h2>
            <p>{getTranslation(i18n, "homePage.benefit4.description")}</p>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={onLearnMoreClick}
            >
              {getTranslation(i18n, "homePage.benefit4.button")}
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
